/**
 * FreeFic 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const freeficPaymentConfig: BrandPaymentConfig = {
  brand: 'freefic',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/freefic/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/freefic/member_subscribe_bg.webp',
      memberSubscribeBg: '/images/freefic/member_subscribe_bg.webp',
      vipIcon: '/images/freefic/vip-icon.png',
      vipDiscountIcon: '/images/freefic/vip-icon.png',
      discountBg: '/images/freefic/member_subscribe_bg.webp',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(315deg, #E65F3D 0%, #FFAD75 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #E65F3D 0%, #FFAD75 70%, #FFF7EF 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #E65F3D, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#E65F3D',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#FFF7EF',
      subscribeActiveBg: '#FFE8D7',
      purpleTextGradient: 'linear-gradient(180deg, #E65F3D 0%, #FFAD75 70%, #FFF7EF 100%)',
      pinkGradient: 'linear-gradient(315deg, #E65F3D 0%, #FFAD75 100%)',
      memberSubscribeBg: '/images/freefic/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
